import isValid from 'date-fns/isValid';
import format from 'date-fns/format';

export default function formatDate(date, lastYear = false) {
  if (isValid(date) && date.getFullYear) {
    const _date = new Date(date.getTime());
    if (lastYear) {
      _date.setFullYear(date.getFullYear() - 1);
    }
    return format(_date, 'yyyy-M-d');
  } else {
    return date;
  }
}
